import { useTranslation } from 'react-i18next';

export default function ExchangeAboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-br from-amber-900 to-yellow-900 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full bg-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=subtle%20gold%20hexagon%20pattern%20texture%20seamless%20background%20luxury%20financial%20abstract%20minimal%20geometric%20design%20warm%20tones&width=400&height=400&seq=exchange-pattern-bg-001&orientation=squarish')`,
            backgroundSize: '200px 200px'
          }}
        ></div>
      </div>

      <div className="relative z-10 container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left: Exchange Introduction */}
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-400/20 border border-amber-400/30 rounded-full px-5 py-2 mb-8">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-history-fill text-amber-300 text-sm"></i>
              </div>
              <span className="text-amber-200 text-sm font-semibold tracking-widest uppercase">
                {t('license.exchange.badge')}
              </span>
            </div>

            <h2 className="text-3xl font-bold text-white mb-6 leading-tight">
              {t('license.exchange.title')}
            </h2>
            <p className="text-amber-100/80 leading-relaxed mb-6">
              {t('license.exchange.desc1')}
            </p>
            <p className="text-amber-100/80 leading-relaxed">
              {t('license.exchange.desc2')}
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <div className="text-3xl font-bold text-amber-300 mb-1">{t('license.exchange.stat1.value')}</div>
                <div className="text-amber-100/70 text-sm">{t('license.exchange.stat1.label')}</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <div className="text-3xl font-bold text-amber-300 mb-1">{t('license.exchange.stat2.value')}</div>
                <div className="text-amber-100/70 text-sm">{t('license.exchange.stat2.label')}</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <div className="text-3xl font-bold text-amber-300 mb-1">{t('license.exchange.stat3.value')}</div>
                <div className="text-amber-100/70 text-sm">{t('license.exchange.stat3.label')}</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <div className="text-3xl font-bold text-amber-300 mb-1">{t('license.exchange.stat4.value')}</div>
                <div className="text-amber-100/70 text-sm">{t('license.exchange.stat4.label')}</div>
              </div>
            </div>
          </div>

          {/* Right: Exchange image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Hong%20Kong%20gold%20exchange%20trading%20floor%20historic%20prestigious%20building%20interior%20classical%20Chinese%20financial%20institution%20grand%20architecture%20ornate%20interior%20gold%20trading%20hall%20professional%20traders%20classic%20formal%20setting&width=700&height=500&seq=exchange-interior-img-001&orientation=landscape"
                alt="Hong Kong Gold & Silver Exchange Society"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white font-semibold text-lg">{t('license.exchange.img.caption')}</p>
                <p className="text-amber-200 text-sm mt-1">{t('license.exchange.img.sub')}</p>
              </div>
            </div>

            {/* Overlay badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-2xl p-4 shadow-xl">
              <div className="text-white text-center">
                <div className="text-3xl font-bold">10</div>
                <div className="text-xs font-semibold opacity-90">{t('license.exchange.badge.number')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
